import { render, staticRenderFns } from "./patientManagement.vue?vue&type=template&id=bc9c271c&scoped=true"
import script from "./patientManagement.vue?vue&type=script&lang=js"
export * from "./patientManagement.vue?vue&type=script&lang=js"
import style0 from "./patientManagement.vue?vue&type=style&index=0&id=bc9c271c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc9c271c",
  null
  
)

export default component.exports